module.exports = __webpack_public_path__ + "img/login_title_unicore.fbe2705a.png";